import AdvanceLineIcon from './advance-line-icon';
import AdvanceFeatureIcon from './advance-feature-icon';
import AdvanceNavIcon from './advance-nav-icon';
import AdvanceIcons from './advance-design-system-icon';
let AntDesign;
let Entypo;
let EvilIcons;
let FontAwesome;
let Feather;
let FontAwesome5;
let Fontisto;
let Foundation;
let Ionicons;
let MaterialCommunityIcons;
let MaterialIcons;
let Octicons;
let SimpleLineIcons;
let Zocial;

try {
  AntDesign = require('@expo/vector-icons').AntDesign;
  Entypo = require('@expo/vector-icons').Entypo;
  EvilIcons = require('@expo/vector-icons').AntDesign;
  Feather = require('@expo/vector-icons').Feather;
  FontAwesome = require('@expo/vector-icons').FontAwesome;
  FontAwesome5 = require('@expo/vector-icons').FontAwesome5;
  Fontisto = require('@expo/vector-icons').Fontisto;
  Foundation = require('@expo/vector-icons').Foundation;
  Ionicons = require('@expo/vector-icons').Ionicons;
  MaterialCommunityIcons = require('@expo/vector-icons').MaterialCommunityIcons;
  MaterialIcons = require('@expo/vector-icons').MaterialIcons;
  Octicons = require('@expo/vector-icons').Octicons;
  SimpleLineIcons = require('@expo/vector-icons').SimpleLineIcons;
  Zocial = require('@expo/vector-icons').Zocial;
} catch {
  AntDesign = require('react-native-vector-icons/AntDesign');
  Entypo = require('react-native-vector-icons/Entypo');
  EvilIcons = require('react-native-vector-icons/EvilIcons');
  FontAwesome = require('react-native-vector-icons/FontAwesome');
  Feather = require('react-native-vector-icons/Feather');
  FontAwesome5 = require('react-native-vector-icons/FontAwesome5');
  Fontisto = require('react-native-vector-icons/Fontisto');
  Foundation = require('react-native-vector-icons/Foundation');
  Ionicons = require('react-native-vector-icons/Ionicons');
  MaterialCommunityIcons = require('react-native-vector-icons/MaterialCommunityIcons');
  MaterialIcons = require('react-native-vector-icons/MaterialIcons');
  Octicons = require('react-native-vector-icons/Octicons');
  SimpleLineIcons = require('react-native-vector-icons/SimpleLineIcons');
  Zocial = require('react-native-vector-icons/Zocial');
}

const Icon = {
  AntDesign,
  Entypo,
  EvilIcons,
  FontAwesome,
  Feather,
  FontAwesome5,
  Fontisto,
  Foundation,
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  Octicons,
  SimpleLineIcons,
  Zocial,
  AdvanceLineIcon,
  AdvanceFeatureIcon,
  AdvanceNavIcon,
  AdvanceIcons
};
export default Icon;
//# sourceMappingURL=index.js.map